import { apiUrl } from "../config/api";


let refreshPromise = null;


export const clearAuthTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};


export const refreshAccessToken = async () => {
  // Évite deux refresh simultanés.
  // Important avec ROTATE_REFRESH_TOKENS=True :
  // le premier refresh invalide l'ancien token.
  if (refreshPromise) {
    return refreshPromise;
  }

  refreshPromise = (async () => {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      clearAuthTokens();
      return null;
    }

    try {
      const response = await fetch(
        apiUrl("/api/dashboard/token/refresh/"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            refresh: refreshToken,
          }),
        }
      );

      if (!response.ok) {
        clearAuthTokens();
        return null;
      }

      const data = await response.json();

      if (!data.access) {
        clearAuthTokens();
        return null;
      }

      localStorage.setItem(
        "accessToken",
        data.access
      );

      // SimpleJWT renvoie un nouveau refresh
      // avec ROTATE_REFRESH_TOKENS=True.
      if (data.refresh) {
        localStorage.setItem(
          "refreshToken",
          data.refresh
        );
      }

      return data.access;

    } catch {
      clearAuthTokens();
      return null;
    }
  })();

  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
};


export const authFetch = async (
  path,
  options = {}
) => {
  const makeRequest = async (token) => {
    const headers = new Headers(
      options.headers || {}
    );

    if (token) {
      headers.set(
        "Authorization",
        `Bearer ${token}`
      );
    }

    return fetch(
      apiUrl(path),
      {
        ...options,
        headers,
      }
    );
  };

  const accessToken =
    localStorage.getItem("accessToken");

  let response = await makeRequest(accessToken);

  // Token toujours valide :
  // aucune raison de faire un refresh.
  if (response.status !== 401) {
    return response;
  }

  // Access token expiré :
  // on tente un renouvellement.
  const newAccessToken =
    await refreshAccessToken();

  if (!newAccessToken) {
    return response;
  }

  // On rejoue UNE seule fois la requête
  // avec le nouvel access token.
  response = await makeRequest(
    newAccessToken
  );

  return response;
};


export const logoutUser = async () => {
  const refreshToken =
    localStorage.getItem("refreshToken");

  try {
    if (refreshToken) {
      await fetch(
        apiUrl("/api/dashboard/logout/"),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            refresh: refreshToken,
          }),
        }
      );
    }
  } catch {
    // Même si Django est inaccessible,
    // on termine la déconnexion locale.
  } finally {
    clearAuthTokens();
  }
};